export default __webpack_public_path__ + "static/logo-c1ed05a013c653a65bfd2e5bbd476e6f.svg";